
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FileItemProps } from ".";
import { loading, update } from "store/file";

interface ApiFileUpdateInputProps extends FileItemProps {
    folderId?: number;
}

type ApiFileUpdateOutputProps = OutputBaseProps<{ item: FileItemProps; }, ApiFileUpdateInputProps>;

export const apiFileUpdate = async (data: ApiFileUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiFileUpdateOutputProps>("/api/file/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
    }
    return res;
};